/*
 * Copyright (c) 2024 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import { JSONable } from '@irian-ro/abstract-resource';
import { Maybe } from '@irian-ro/util-functions';

export class ETransportConfirmationMessageVO extends JSONable {
  tipConf: Maybe<string> | undefined = undefined;
  obs: Maybe<string> | undefined = undefined;
  postAvarie: Maybe<string> | undefined = undefined;
  sursa: Maybe<string> | undefined = undefined;
  dataDecl: Maybe<string> | undefined = undefined;
  idIncarcare: Maybe<string> | undefined = undefined;
}
